const periodParamNames = ['period', 'period_from_date', 'period_to_date'];

const getPeriodFilters = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const newParams = new URLSearchParams('');

  for (let i = 0; i < periodParamNames.length; i += 1) {
    const paramName = periodParamNames[i];
    const paramValue = searchParams.get(paramName);
    if (paramValue) {
      newParams.set(paramName, paramValue);
    }
  }

  const queryString = newParams.toString();
  return queryString ? `?${queryString}` : '';
};

const performance = (store, ref_no) => `/apps/${store}/${ref_no}/performance${getPeriodFilters()}`;
const growth = (store, ref_no) => `/apps/${store}/${ref_no}/performance${getPeriodFilters()}`;
const engagement = (store, ref_no) => `/apps/${store}/${ref_no}/engagement${getPeriodFilters()}`;
const retention = (store, ref_no) => `/apps/${store}/${ref_no}/user_retention${getPeriodFilters()}`;
const ranks = (store, ref_no) => `/apps/${store}/${ref_no}/rank_history${getPeriodFilters()}`;
const demographics = (store, ref_no) =>
  `/apps/${store}/${ref_no}/demographics${getPeriodFilters()}`;
const advertisingOverview = (store, ref_no) =>
  `/ad-intelligence/advertising-overview/${store}/${ref_no}${getPeriodFilters()}`;
const organicKeywords = (store, ref_no) =>
  `/search-analysis/organic_keywords/${store}/${ref_no}${getPeriodFilters()}`;
const paidKeywords = (store, ref_no) =>
  `/search-analysis/paid_searches/${store}/${ref_no}${getPeriodFilters()}`;
const sentiments = (store, ref_no) =>
  `/review-analysis/sentiments/${store}/${ref_no}${getPeriodFilters()}`;
const sdks = (store, ref_no) => `/apps/${store}/${ref_no}/sdks${getPeriodFilters()}`;
const xray = (store, ref_no) => `/x-ray/app_analysis/${store}/${ref_no}${getPeriodFilters()}`;

export default {
  performance,
  growth,
  engagement,
  retention,
  ranks,
  demographics,
  advertisingOverview,
  organicKeywords,
  paidKeywords,
  sentiments,
  sdks,
  xray,
};
